module.exports = __webpack_public_path__ + "static/media/Bogota.949c1a25.jpg";